import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";
import { getBrandCustom } from "../utils/getCustomColor";

const styles = makeStyles(() => ({
  footerPageSize: {
    display: "flex",
    alignItems: "center",
  },
  select: {
    height: "40px",
  },
  textSelect: {
    color: getBrandCustom("primaryColor", colors.brandBlue500),
  },
  buttonPage: {
    backgroundColor: "#ffffff",
    minWidth: "44px",
    width: "44px",
    height: "44px",
    textAlign: "center",
    borderTop: "1px solid #e4e7ec !important",
    borderBottom: "1px solid #e4e7ec !important",
    borderRight: "1px solid #e4e7ec !important",
    borderLeft: "none !important",
    borderRadius: 0,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0em",
    color: "#667085",
  },
  buttonSelected: {
    color: getBrandCustom("primaryColor", colors.brandBlue500),
  },
  buttonPageFirst: {
    borderRadius: 0,
    borderLeft: "1px solid #e4e7ec !important",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
  },
  buttonPageNext: {
    borderRadius: 0,
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
  },
  gridFooter: {
    padding: "15px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },
  gridFooterOptions: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
  },
  footerShowInfo: {
    display: "flex",
    alignItems: "center",
    fontSize: "13px",
    marginBottom: "5px",
  },
  textFooterShowInfo: {
    color: colors.gray800,
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "16px",
  },
}));

export default styles;
